export enum DetailedTicketSource {
    formExternal = 101,
    formInternal = 104,
    formForward = 105,

    facebookPost = 201,
    facebookImage = 202,
    facebookMention = 203,
    facebookPrivateMessage = 204,
    facebookReview = 205,
    facebookEvent = 206,
    facebookVideo = 207,
    facebookShare = 208,
    facebookDnbBot = 209,
    facebookGroup = 210,

    instagramTag = 401,
    instagramAccount = 402,
    instagramMention = 403, // InstagramMentionInCaption
    instagramPhotoTag = 404,
    instagramDirectMessage = 405,

    email = 501,
    emailOutlookPlugin = 502,

    chat = 601,
    chatPublicAPI = 602,

    youtubeVideoComment = 701,
    youtubeDiscussion = 702,

    slackChannel = 801,
    slackDirect = 802,
    slackGroup = 803,

    linkedinCompanyPagePost = 901,
    linkedinCompanyAds = 902,

    googleMyBusinessLocationReview = 1001,
    googleMyBusinessLocationQuestion = 1002,

    trustpilotServiceReview = 1101,

    googlePlayMarketReview = 1201,

    appStoreReview = 1301,

    whatsAppConversation = 1401,

    tikTokVideo = 1501,

    api = 1601,
}
